import { ChangeDetectorRef, Component, inject, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Tree } from 'primeng/tree';
import { ComponentView } from 'src/modules/app-template/models/component-view.model';
import { SmTabViewComponent } from 'src/modules/sm-base/components/sm-tab-view/sm-tab-view.component';
import { RestEndpoint } from 'src/modules/sm-base/models/rest-endpoint.model';
import { GuiUtils } from "src/modules/utils/misc/gui-utils";
import { TreeNode2 } from 'src/modules/utils/misc/tree-node2.model';
import { TreeSelectionHelper } from 'src/modules/utils/misc/tree-selection-helper';
import { Arrays } from 'src/modules/utils/shared/arrays';
import { ObjectOfSimpleDataTypes } from 'src/modules/utils/shared/object-of-simple-data-types.model';
import { Objects } from "src/modules/utils/shared/objects";
import { Strings } from "src/modules/utils/shared/strings";
import { Utils } from 'src/modules/utils/shared/utils';
import { RungisSupplierService } from '../../services/rungis-supplier.service';
import { Additive } from '../../shared/additive.entity';
import { AdditiveProductInformation } from '../../shared/additiveProductInformation.entity';
import { CustomsNumber } from '../../shared/customsNumber.entity';
import { ProductInformation } from '../../shared/productInformation.entity';

@Component({
    selector: 'app-rungis-supplier',
    templateUrl: './rungis-supplier.component.html',
    styleUrls: ['./rungis-supplier.component.scss'],
    standalone: false
})
export class RungisSupplierComponent extends ComponentView {
 
  service = inject(RungisSupplierService);
  cdr = inject(ChangeDetectorRef);

  id: string;
  productInformation: ProductInformation;
  customsNumbers: CustomsNumber[];
  allAdditives: Additive[];
  selectedAdditives: { [category: string]: AdditiveProductInformation[] } = {};
  uniqueCategories: string[];
  groupedAdditives: { [category: string]: AdditiveProductInformation[] } = {};
  formValid = true;
  customsNumberValid = false;
  allAllergensStatus = "";

  neededParams: ObjectOfSimpleDataTypes = { id: "string" };

  activeTab = "0";
  formDate = new Date();

  eudrTree: TreeSelectionHelper;

  @ViewChild("supplierForm") supplierForm: NgForm;
  @ViewChild("tree") tree: Tree;
  @ViewChild('tabView') tabView: SmTabViewComponent; 

    
  async initParams(): Promise<boolean> {
    this.fullScreenComponent = false;
    await this.reload();
    if (this.productInformation.requestPostProcessing) {
        
        this.productInformation.logisticsEANPieceNotAvailable = this.productInformation.logisticsEANPiece == "" || this.productInformation.logisticsEANPiece == "0";
        this.productInformation.logisticsEANBoxNotAvailable = this.productInformation.logisticsEANBox == "" || this.productInformation.logisticsEANBox == "0";
        this.productInformation.logisticsNetWeightPieceNotAvailable = this.productInformation.logisticsNetWeightPiece == "" || this.productInformation.logisticsNetWeightPiece == "0";
        this.productInformation.logisticsNetWeightBoxNotAvailable = this.productInformation.logisticsNetWeightBox == "" || this.productInformation.logisticsNetWeightBox == "0";
        this.productInformation.logisticsGrossWeightPieceNotAvailable = this.productInformation.logisticsGrossWeightPiece == "" || this.productInformation.logisticsGrossWeightPiece == "0";
        this.productInformation.logisticsGrossWeightBoxNotAvailable = this.productInformation.logisticsGrossWeightBox == "" || this.productInformation.logisticsGrossWeightBox == "0";
        this.productInformation.logisticsDimensionsPieceNotAvailable = 
            (this.productInformation.logisticsDimensionsPieceB == "" || this.productInformation.logisticsDimensionsPieceB == "0") && 
            (this.productInformation.logisticsDimensionsPieceH == "" || this.productInformation.logisticsDimensionsPieceH == "0") &&
            (this.productInformation.logisticsDimensionsPieceL == "" || this.productInformation.logisticsDimensionsPieceL == "0");
            this.productInformation.logisticsDimensionsBoxNotAvailable = 
            (this.productInformation.logisticsDimensionsBoxB == "" || this.productInformation.logisticsDimensionsBoxB == "0") && 
            (this.productInformation.logisticsDimensionsBoxH == "" || this.productInformation.logisticsDimensionsBoxH == "0") &&
            (this.productInformation.logisticsDimensionsBoxL == "" || this.productInformation.logisticsDimensionsBoxL == "0");
        this.productInformation.packagingAluminumWeightNotAvailable = this.productInformation.packagingAluminumWeight == "" || this.productInformation.packagingAluminumWeight == "0";
        this.productInformation.packagingCompositeWeightNotAvailable = this.productInformation.packagingCompositeWeight == "" || this.productInformation.packagingCompositeWeight == "0";
        this.productInformation.packagingGlassWeightNotAvailable = this.productInformation.packagingGlassWeight == "" || this.productInformation.packagingGlassWeight == "0";
        this.productInformation.packagingNaturalWeightNotAvailable = this.productInformation.packagingNaturalWeight == "" || this.productInformation.packagingNaturalWeight == "0";
        this.productInformation.packagingPaperWeightNotAvailable = this.productInformation.packagingPaperWeight == "" || this.productInformation.packagingPaperWeight == "0";
        this.productInformation.packagingPlasticWeightNotAvailable = this.productInformation.packagingPlasticWeight == "" || this.productInformation.packagingPlasticWeight == "0";
        this.productInformation.packagingTinplateWeightNotAvailable = this.productInformation.packagingTinplateWeight == "" || this.productInformation.packagingTinplateWeight == "0";
        this.productInformation.hintsGeneticallyModified = this.productInformation.hintsGeneticallyModified != "" ? this.productInformation.hintsGeneticallyModified : "Nicht vorhanden";
        this.productInformation.hintsProducedGeneticallyModifiedOrganisms = this.productInformation.hintsProducedGeneticallyModifiedOrganisms != "" ? this.productInformation.hintsProducedGeneticallyModifiedOrganisms : "Nicht vorhanden";
        this.productInformation.hintsObtainedGeneticallyModifiedOrganisms = this.productInformation.hintsObtainedGeneticallyModifiedOrganisms != "" ? this.productInformation.hintsObtainedGeneticallyModifiedOrganisms : "Nicht vorhanden";
        this.productInformation.hintsIonizingRadiation = this.productInformation.hintsIonizingRadiation != "" ? this.productInformation.hintsIonizingRadiation : "Nicht vorhanden";
        this.productInformation.hintsIonizingRadiationIngredients = this.productInformation.hintsIonizingRadiationIngredients != "" ? this.productInformation.hintsIonizingRadiationIngredients : "Nicht vorhanden";
        this.productInformation.detailsSpecificationChecked = true;
        this.productInformation.detailsGermanLabel = "yes";
        this.productInformation.uploadRequired = false;
    }
    this.productInformation.confirmationDate = new Date();
    this.allAdditives = await this.service.getAdditives();
    this.uniqueCategories = this.getUniqueCategories();
    this.groupAdditivesByCategory();
    this.customsNumbers = await this.service.getCustomsNumbers();

    this.productInformation.additives.forEach(additive => {
      additive.additive = this.allAdditives.find(a => a.eNumber == additive.eNumber && a.category == additive.category);
      additive.label = additive.eNumber + " - " + (
        this.app.language == "de" ? additive.additive?.descriptionGerman :  
        this.app.language == "en" ? additive.additive?.descriptionEnglish : 
        this.app.language == "fr" ? additive.additive?.descriptionFrench : 
        this.app.language == "es" ? additive.additive?.descriptionSpanish : "???");
      if (additive.active) {
        if (!this.selectedAdditives[additive.category]) {
          this.selectedAdditives[additive.category] = [];
        }
        this.selectedAdditives[additive.category].push(additive);
      }
    });
    if (this.productInformation.detailsCustomsFeeNumber.length > 0) {
      this.checkCustomsNumber();
    }

    let trans = this.app.getTranslationMap();

    this.eudrTree = new TreeSelectionHelper(this.tree);
    let eudrItems: TreeNode2[] = [];
    for (let cat of Objects.getPropertyNames(trans.rungis.basic.eudrCategories)) {
        let catNode: TreeNode2 = { label: trans.rungis.basic.eudrCategories[cat].label ?? cat, data: "category" + cat, children: [], key: "category" + cat};
        eudrItems.push(catNode);
        for (let item of Objects.getPropertyNames(trans.rungis.basic.eudrCategories[cat])) {
            if(item === 'label') {
                continue;
            }
            let node = { label: trans.rungis.basic.eudrCategories[cat][item], data: item, key: item };
            catNode.children.push(node);
        }
    }

    this.eudrTree.setItems(eudrItems, true);
    this.eudrTree.setSelected(Arrays.withoutNull(Strings.split(Arrays.getSafe(Strings.splitLines(this.productInformation.eudrItems), 0), "|")));

    return true;
  }

  groupAdditivesByCategory(): void {
    this.uniqueCategories = Array.from(new Set(this.productInformation.additives.map(additive => additive.category)));
    for (const category of this.uniqueCategories) {
      this.groupedAdditives[category] = this.productInformation.additives.filter(additive => additive.category === category);
    }
  }

  eudrChanged(): void {

  }
  
  onAdditiveSelectionChange(category: string): void {
    const selectedAdditives = this.selectedAdditives[category] ?? [];
    const selectedAdditiveIDs = new Set(selectedAdditives.map((v) => v.id));

    for(const additive of this.groupedAdditives[category] ?? []) {
        additive.active = selectedAdditiveIDs.has(additive.id);
    }
  }

  getUniqueCategories(): string[] {
    const uniqueCategories: string[] = [];
    for (const additive of this.productInformation.additives) {
      if (!uniqueCategories.includes(additive.category)) {
        uniqueCategories.push(additive.category);
      }
    }
    return uniqueCategories;
  }

  getAdditivesForCategory(category: string): { name: string; value: string; lbl: string }[] {
    const additivesForCategory: { name: string; value: string; lbl: string }[] = [];
    const additives = this.productInformation.additives.filter(additive => additive.category === category);
    for (const additive of additives) {
      const formattedLabel = `${additive.eNumber} - ${additive.additiveDescription}`;
      additivesForCategory.push({
        name: formattedLabel,
        value: additive.eNumber,
        lbl: formattedLabel
      });
    }
    return additivesForCategory;
  }

  calculateGuaranteedBestBefore(): void {
    this.productInformation.detailsGuaranteedBestBefore = Math.ceil(this.productInformation.detailsBestBeforeDays * 0.7);
  }

  calculateTotal(): void {
    this.productInformation.packagingTotalPerPalette = this.productInformation.packagingPiecesPerBox * this.productInformation.packagingBoxesPerLayer * this.productInformation.packagingLayersPerPalette;
  }

  pieceDimensionChecked(): void {
    if (this.productInformation.logisticsDimensionsPieceNotAvailable) {
      this.productInformation.logisticsDimensionsPieceL = "";
      this.productInformation.logisticsDimensionsPieceB = "";
      this.productInformation.logisticsDimensionsPieceH = "";
    }
  }

  boxDimensionChecked(): void {
    if (this.productInformation.logisticsDimensionsPieceNotAvailable) {
      this.productInformation.logisticsDimensionsBoxL = "";
      this.productInformation.logisticsDimensionsBoxB = "";
      this.productInformation.logisticsDimensionsBoxH = "";
    }
  }

  async reload(): Promise<void> {    
    this.productInformation = await this.app.loadDataHandler(() => RestEndpoint.main().query({ id: this.id }).run("api/run/productInformation/byWf").get(ProductInformation, true), this);
  }

  async upload(_, ft: string): Promise<void> {
    if (ft === "productImage" && this.productInformation.detailsProductImagesFiles?.length == 3) {
      this.app.showErrorToast("Es können maximal drei Produktbilder hochgeladen werden.");
    }
    else {
      let uploadedFile = await this.app.fileUpload.chooseFile();
      let uploadedFileContents = uploadedFile[0].contents;
      await this.save();
      await RestEndpoint.main().post().body({ wfId: this.productInformation.wfId, fileType: ft, fileBase64: Strings.bytesToBase64(uploadedFileContents), fileName: uploadedFile[0].legacy.name}).run("api/run/productInformation/upload").getText();
      await this.reload();
    }
}

  async submitForm(): Promise<void> {
    if (await this.save(true, true)) {
        this.app.showToast("success", "Erfolgreich gesendet", "Die Daten wurden erfolgreich gesendet. Sie können dieses Fenster nun schließen.", 20000);
    }
  }

    dateOfSpecificationInvalid(): boolean {
        let date = this.productInformation.detailsDateOfSpecification;
        if (!date) {
            return false;
        }
        let today = new Date();
        today.setHours(0, 0, 0, 0);
        let inputDate = new Date(date);
        return inputDate > today;
}

  checkSpecificationDate(): boolean {
    if (!this.productInformation.detailsDateOfSpecification) {
      return false;
    }
    const currentDate = new Date();
    const selectedDate = new Date(this.productInformation.detailsDateOfSpecification);

    const twoYearsAgo = new Date();
    twoYearsAgo.setFullYear(currentDate.getFullYear() - 2);

    return selectedDate < twoYearsAgo;
  }

  checkRequiredBeef(): boolean {
    let required = Utils.isNoe(this.productInformation.fleischZuchtRasse) && Utils.isNoe(this.productInformation.meatButcheredIn) && Utils.isNoe(this.productInformation.meatGrownIn) && Utils.isNoe(this.productInformation.haltungsform);
    if (!required) {
        this.productInformation.fleischRasseZucht = "";
        this.productInformation.beefBornIn = "";
        this.productInformation.beefButcheredIn = "";
        this.productInformation.beefCutIn = "";
        this.productInformation.beefGrownIn = "";
    }
    return required;
  }

  checkRequiredMeat(): boolean {
    let required = Utils.isNoe(this.productInformation.fleischRasseZucht) && Utils.isNoe(this.productInformation.beefBornIn) && Utils.isNoe(this.productInformation.beefButcheredIn) && Utils.isNoe(this.productInformation.beefCutIn) && Utils.isNoe(this.productInformation.beefGrownIn);
    if (!required) {
        this.productInformation.fleischZuchtRasse = "";
        this.productInformation.meatGrownIn = "";
        this.productInformation.meatButcheredIn = "";
        this.productInformation.haltungsform = "";
    }
    return required;
  }

  async previousTab(): Promise<void> {
    this.activeTab = Objects.toString(Utils.toNumber(this.activeTab) - 1); 
    await this.save();
  }

  async nextTab(): Promise<void> {
    this.activeTab = Objects.toString(Utils.toNumber(this.activeTab) + 1); 
    await this.save();
  }

  async save(toast = false, finish = false): Promise<boolean> {
    let errors = false;
    for (let name of Objects.getPropertyNames(this.supplierForm.controls)) {
        let control = this.supplierForm.controls[name];
        if (control.invalid) {
            let inputEl = document.querySelector(`[name="${name}"]`) ;
            if (inputEl) {
                let labelText = this.findLabelForInputElement(inputEl as HTMLElement);
                let errorMessage = "Ungültiges Feld: " + (labelText || name);
                console.log(errorMessage);
                if (toast) {
                    this.app.showErrorToast(errorMessage);
                    this.tabView?.navigateToElement(inputEl as HTMLElement);
                }
            }
            errors = true;
            break;
        }
    }

    this.productInformation.eudrItems = Arrays.itemsToString(this.eudrTree.getSelected(), '|') + '\n\n' + Arrays.itemsToString(this.eudrTree.getSelectedNodes(), '\n', item => item.label); 
    if (!errors && finish) {
        this.productInformation.requestFinished = true;    
    }    
    await this.app.saveDataHandler(async () => RestEndpoint.main().body(this.productInformation).post().run("api/run/productInformation").getText(), this, true, false);
    return !errors;
  }

  findLabelForInputElement(inputEl: HTMLElement): string | null {
    let parent = inputEl.parentElement;
  
    while (parent && parent !== document.body) {
      let label = parent.querySelector('label');
      if (label) {
        return label.textContent?.trim() || null;
      }
  
      parent = parent.parentElement;
    }
  
    return null;
  }

   ngAfterViewChecked(): void {
     this.cdr.detectChanges();
   }

  disableAllergens(): void {
    if (this.productInformation.allergenesNotAvailable) {
      this.productInformation.allergens.forEach(allergen => {
        allergen.status = 'nicht vorhanden';
      });
    }
    else {
      this.productInformation.allergens.forEach(allergen => {
        allergen.status = '';
      });
    }
  }

  isEanValid(ean: string): boolean {
    return Utils.isNoe(ean) || Utils.isEanValid(ean);
  }

  fatChanged(): void {
    this.productInformation.nutritionFat = parseFloat(this.productInformation.nutritionFat.replace(",", ".")) > 100 ? "100" : this.productInformation.nutritionFat;
    let total = parseFloat(this.productInformation.nutritionCarbs.replace(",", ".")) + parseFloat(this.productInformation.nutritionFat.replace(",", ".")) + parseFloat(this.productInformation.nutritionProtein.replace(",", ".")) + parseFloat(this.productInformation.nutritionSalt.replace(",", "."));
    if (total > 100) {
      let fatStr = this.productInformation.nutritionFat.replace(",", ".");
      let fat = parseFloat(fatStr);
      let newFat = 100 - (total - fat);
      this.productInformation.nutritionFat = newFat.toString().replace(".", ",");//(100 - (total - parseFloat(this.productInformation.nutritionFat.toString().replace(",", ".")))).toString().replace(".", ",");
    }
  }

  saturatedFatChanged(): void {
    if (Utils.toNumber(this.productInformation.nutritionsaturatedFat, false, true, 0) > Utils.toNumber(this.productInformation.nutritionFat, false, true, 0)) {
        this.productInformation.nutritionsaturatedFat = this.productInformation.nutritionFat;
    }
  }

  carbsChanged(): void {
    this.productInformation.nutritionCarbs = parseFloat(this.productInformation.nutritionCarbs.replace(",", ".")) > 100 ? "100" : this.productInformation.nutritionCarbs;
    let total = parseFloat(this.productInformation.nutritionCarbs.replace(",", ".")) + parseFloat(this.productInformation.nutritionFat.replace(",", ".")) + parseFloat(this.productInformation.nutritionProtein.replace(",", ".")) + parseFloat(this.productInformation.nutritionSalt.replace(",", "."));
    if (total > 100) {
      let carbsStr = this.productInformation.nutritionCarbs.replace(",", ".");
      let carbs = parseFloat(carbsStr);
      let newCarbs = 100 - (total - carbs);
      this.productInformation.nutritionCarbs = newCarbs.toString().replace(".", ",");//(100 - (total - parseFloat(this.productInformation.nutritionCarbs.toString().replace(",", ".")))).toString().replace(".", ",");
    }
  }

  proteinChanged(): void {
    this.productInformation.nutritionProtein = parseFloat(this.productInformation.nutritionProtein.replace(",", ".")) > 100 ? "100" : this.productInformation.nutritionProtein;
    let total = parseFloat(this.productInformation.nutritionCarbs.replace(",", ".")) + parseFloat(this.productInformation.nutritionFat.replace(",", ".")) + parseFloat(this.productInformation.nutritionProtein.replace(",", ".")) + parseFloat(this.productInformation.nutritionSalt.replace(",", "."));
    if (total > 100) {
      let proteinStr = this.productInformation.nutritionProtein.replace(",", ".");
      let protein = parseFloat(proteinStr);
      let newProtein = 100 - (total - protein);
      this.productInformation.nutritionProtein = newProtein.toString().replace(".", ",");//(100 - (total - parseFloat(this.productInformation.nutritionProtein.toString().replace(",", ".")))).toString().replace(".", ",");
    }
  }

  saltChanged(): void {
    this.productInformation.nutritionSalt = parseFloat(this.productInformation.nutritionSalt.replace(",", ".")) > 100 ? "100" : this.productInformation.nutritionSalt;
    let total = parseFloat(this.productInformation.nutritionCarbs.replace(",", ".")) + parseFloat(this.productInformation.nutritionFat.replace(",", ".")) + parseFloat(this.productInformation.nutritionProtein.replace(",", ".")) + parseFloat(this.productInformation.nutritionSalt.replace(",", "."));
    if (total > 100) {
      let saltStr = this.productInformation.nutritionSalt.replace(",", ".");
      let salt = parseFloat(saltStr);
      let newSalt = 100 - (total - salt);
      this.productInformation.nutritionSalt = newSalt.toString().replace(".", ",");//(100 - (total - parseFloat(this.productInformation.nutritionSalt.toString().replace(",", ".")))).toString().replace(".", ",");
    }
  }

  changeAllAllergens(value: string): void {
    for (let allergen of this.productInformation.allergens) {
        allergen.status = value;
    }  
    GuiUtils.angularTimer(() => {this.allAllergensStatus = null});
  }

  checkNutrition(): void {
    if (this.productInformation.nutritionNA == "erforderlich") {
      this.productInformation.nutritionCarbSugarNA = false;
      this.productInformation.nutritionCarbsNA = false;
      this.productInformation.nutritionFatNA = false;
      this.productInformation.nutritionKjKcalNA = false;
      this.productInformation.nutritionProteinNA = false;
      this.productInformation.nutritionSaltNA = false;
      this.productInformation.nutritionSaturatedFatNA = false;
    }
    else {
      this.productInformation.nutritionCarbSugarNA = true;
      this.productInformation.nutritionCarbsNA = true;
      this.productInformation.nutritionFatNA = true;
      this.productInformation.nutritionKjKcalNA = true;
      this.productInformation.nutritionProteinNA = true;
      this.productInformation.nutritionSaltNA = true;
      this.productInformation.nutritionSaturatedFatNA = true;

      this.productInformation.nutritionCarbs = "0";
      this.productInformation.nutritionCarbsSugar = "0";
      this.productInformation.nutritionFat = "0";
      this.productInformation.nutritionsaturatedFat = "0";
      this.productInformation.nutritionKjKcal = "0";
      this.productInformation.nutritionProtein = "0";
      this.productInformation.nutritionSalt = "0";
    }
  }

  checkCustomsNumber(): void {
        let customsNo = this.customsNumbers.find(c => c.customsNumber === this.productInformation.detailsCustomsFeeNumber);
        this.customsNumberValid = customsNo?.customsNumber.length > 0;

        if (!this.customsNumberValid) {
          this.app.showErrorToast("Die Zolltarif-Nr. ist ungültig.");
        }

        this.productInformation.customsNumberDescription = this.customsNumberValid ? 
            this.app.language == "de" ? customsNo.descriptionGerman :  
            this.app.language == "en" ? customsNo.descriptionEnglish : 
            this.app.language == "fr" ? customsNo.descriptionFrench : 
            this.app.language == "es" ? customsNo.descriptionSpanish : '' : '';
  }

  inlandFisheriesChanged(): void {
    if (!this.productInformation.fishInlandFisheries) {
      this.productInformation.fishInlandOrigin = "";
      this.productInformation.fishInlandGearCategory = "";
    }
  }

  wildCaughtChanged(): void {
    if (!this.productInformation.fishWildCaught) {
      this.productInformation.fishWildGearCategory = "";
      this.productInformation.fishCatchmentArea = "";
      this.productInformation.fishSubCatchmentArea = "";
    }
  }

  aquacultureChanged(): void {
    if (!this.productInformation.fishAquaculture) {
      this.productInformation.fishOriginAC = "";
    }
  }

  escapePropertyName(propName: string): string {
    return Objects.escapeProperty(propName);
  }
}